import { IconType } from "../../types";

interface IconProps {
  name: IconType;
  fill?: string;
  className?: string;
  width?: number;
  height?: number;
}

export const Icon = ({
  name,
  fill = "",
  className = "",
  width = 20,
  height = 20,
  ...props
}: IconProps) => {
  const spritesheet =
    window?.resourceUrls?.iconSpriteSheet ??
    "/marketplace/images/sprite-icon.svg";

  return (
    <svg class={`icon ${className}`} width={width} height={height} {...props}>
      <use href={`${spritesheet}#${name}`} fill={fill} />
    </svg>
  );
};
